"use strict";

exports.__esModule = true;
exports.default = void 0;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function assertNonEmptyString(str) {
  if (typeof str !== 'string' || !str) {
    throw new Error('expected a non-empty string, got: ' + str);
  }
}
function assertNumber(number) {
  if (typeof number !== 'number') {
    throw new Error('expected a number, got: ' + number);
  }
}
var DB_VERSION_CURRENT = 1;
var DB_VERSION_INITIAL = 1;
var STORE_EMOJI = 'emoji';
var STORE_KEYVALUE = 'keyvalue';
var STORE_FAVORITES = 'favorites';
var FIELD_TOKENS = 'tokens';
var INDEX_TOKENS = 'tokens';
var FIELD_UNICODE = 'unicode';
var INDEX_COUNT = 'count';
var FIELD_GROUP = 'group';
var FIELD_ORDER = 'order';
var INDEX_GROUP_AND_ORDER = 'group-order';
var KEY_ETAG = 'eTag';
var KEY_URL = 'url';
var KEY_PREFERRED_SKINTONE = 'skinTone';
var MODE_READONLY = 'readonly';
var MODE_READWRITE = 'readwrite';
var INDEX_SKIN_UNICODE = 'skinUnicodes';
var FIELD_SKIN_UNICODE = 'skinUnicodes';
var DEFAULT_DATA_SOURCE = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json';
var DEFAULT_LOCALE = 'en';

// like lodash's uniqBy but much smaller
function uniqBy(arr, func) {
  var set = new Set();
  var res = [];
  var _iterator = _createForOfIteratorHelper(arr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var key = func(item);
      if (!set.has(key)) {
        set.add(key);
        res.push(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
}
function uniqEmoji(emojis) {
  return uniqBy(emojis, function (_) {
    return _.unicode;
  });
}
function initialMigration(db) {
  function createObjectStore(name, keyPath, indexes) {
    var store = keyPath ? db.createObjectStore(name, {
      keyPath: keyPath
    }) : db.createObjectStore(name);
    if (indexes) {
      for (var _i = 0, _Object$entries = Object.entries(indexes); _i < _Object$entries.length; _i++) {
        var _ref = _Object$entries[_i];
        var _ref2 = _slicedToArray(_ref, 2);
        var indexName = _ref2[0];
        var _ref2$ = _slicedToArray(_ref2[1], 2);
        var _keyPath = _ref2$[0];
        var multiEntry = _ref2$[1];
        store.createIndex(indexName, _keyPath, {
          multiEntry: multiEntry
        });
      }
    }
    return store;
  }
  createObjectStore(STORE_KEYVALUE);
  createObjectStore(STORE_EMOJI, /* keyPath */FIELD_UNICODE, _defineProperty(_defineProperty(_defineProperty({}, INDEX_TOKENS, [FIELD_TOKENS, /* multiEntry */true]), INDEX_GROUP_AND_ORDER, [[FIELD_GROUP, FIELD_ORDER]]), INDEX_SKIN_UNICODE, [FIELD_SKIN_UNICODE, /* multiEntry */true]));
  createObjectStore(STORE_FAVORITES, undefined, _defineProperty({}, INDEX_COUNT, ['']));
}
var openIndexedDBRequests = {};
var databaseCache = {};
var onCloseListeners = {};
function handleOpenOrDeleteReq(resolve, reject, req) {
  // These things are almost impossible to test with fakeIndexedDB sadly
  /* istanbul ignore next */
  req.onerror = function () {
    return reject(req.error);
  };
  /* istanbul ignore next */
  req.onblocked = function () {
    return reject(new Error('IDB blocked'));
  };
  req.onsuccess = function () {
    return resolve(req.result);
  };
}
function createDatabase(_x) {
  return _createDatabase.apply(this, arguments);
}
function _createDatabase() {
  _createDatabase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(dbName) {
    var db;
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          _context13.n = 1;
          return new Promise(function (resolve, reject) {
            var req = indexedDB.open(dbName, DB_VERSION_CURRENT);
            openIndexedDBRequests[dbName] = req;
            req.onupgradeneeded = function (e) {
              // Technically there is only one version, so we don't need this `if` check
              // But if an old version of the JS is in another browser tab
              // and it gets upgraded in the future and we have a new DB version, well...
              // better safe than sorry.
              /* istanbul ignore else */
              if (e.oldVersion < DB_VERSION_INITIAL) {
                initialMigration(req.result);
              }
            };
            handleOpenOrDeleteReq(resolve, reject, req);
          });
        case 1:
          db = _context13.v;
          // Handle abnormal closes, e.g. "delete database" in chrome dev tools.
          // No need for removeEventListener, because once the DB can no longer
          // fire "close" events, it will auto-GC.
          // Unfortunately cannot test in fakeIndexedDB: https://github.com/dumbmatter/fakeIndexedDB/issues/50
          /* istanbul ignore next */
          db.onclose = function () {
            return closeDatabase(dbName);
          };
          return _context13.a(2, db);
      }
    }, _callee13);
  }));
  return _createDatabase.apply(this, arguments);
}
function openDatabase(dbName) {
  if (!databaseCache[dbName]) {
    databaseCache[dbName] = createDatabase(dbName);
  }
  return databaseCache[dbName];
}
function dbPromise(db, storeName, readOnlyOrReadWrite, cb) {
  return new Promise(function (resolve, reject) {
    // Use relaxed durability because neither the emoji data nor the favorites/preferred skin tone
    // are really irreplaceable data. IndexedDB is just a cache in this case.
    var txn = db.transaction(storeName, readOnlyOrReadWrite, {
      durability: 'relaxed'
    });
    var store = typeof storeName === 'string' ? txn.objectStore(storeName) : storeName.map(function (name) {
      return txn.objectStore(name);
    });
    var res;
    cb(store, txn, function (result) {
      res = result;
    });
    txn.oncomplete = function () {
      return resolve(res);
    };
    /* istanbul ignore next */
    txn.onerror = function () {
      return reject(txn.error);
    };
  });
}
function closeDatabase(dbName) {
  // close any open requests
  var req = openIndexedDBRequests[dbName];
  var db = req && req.result;
  if (db) {
    db.close();
    var listeners = onCloseListeners[dbName];
    /* istanbul ignore else */
    if (listeners) {
      var _iterator2 = _createForOfIteratorHelper(listeners),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var listener = _step2.value;
          listener();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }
  delete openIndexedDBRequests[dbName];
  delete databaseCache[dbName];
  delete onCloseListeners[dbName];
}
function deleteDatabase(dbName) {
  return new Promise(function (resolve, reject) {
    // close any open requests
    closeDatabase(dbName);
    var req = indexedDB.deleteDatabase(dbName);
    handleOpenOrDeleteReq(resolve, reject, req);
  });
}

// The "close" event occurs during an abnormal shutdown, e.g. a user clearing their browser data.
// However, it doesn't occur with the normal "close" event, so we handle that separately.
// https://www.w3.org/TR/IndexedDB/#close-a-database-connection
function addOnCloseListener(dbName, listener) {
  var listeners = onCloseListeners[dbName];
  if (!listeners) {
    listeners = onCloseListeners[dbName] = [];
  }
  listeners.push(listener);
}

// list of emoticons that don't match a simple \W+ regex
// extracted using:
// require('emoji-picker-element-data/en/emojibase/data.json').map(_ => _.emoticon).filter(Boolean).filter(_ => !/^\W+$/.test(_))
var irregularEmoticons = new Set([':D', 'XD', ":'D", 'O:)', ':X', ':P', ';P', 'XP', ':L', ':Z', ':j', '8D', 'XO', '8)', ':B', ':O', ':S', ":'o", 'Dx', 'X(', 'D:', ':C', '>0)', ':3', '</3', '<3', '\\M/', ':E', '8#']);
function extractTokens(str) {
  return str.split(/[\s_]+/).map(function (word) {
    if (!word.match(/\w/) || irregularEmoticons.has(word)) {
      // for pure emoticons like :) or :-), just leave them as-is
      return word.toLowerCase();
    }
    return word.replace(/[)(:,]/g, '').replace(/’/g, "'").toLowerCase();
  }).filter(Boolean);
}
var MIN_SEARCH_TEXT_LENGTH = 2;

// This is an extra step in addition to extractTokens(). The difference here is that we expect
// the input to have already been run through extractTokens(). This is useful for cases like
// emoticons, where we don't want to do any tokenization (because it makes no sense to split up
// ">:)" by the colon) but we do want to lowercase it to have consistent search results, so that
// the user can type ':P' or ':p' and still get the same result.
function normalizeTokens(str) {
  return str.filter(Boolean).map(function (_) {
    return _.toLowerCase();
  }).filter(function (_) {
    return _.length >= MIN_SEARCH_TEXT_LENGTH;
  });
}

// Transform emoji data for storage in IDB
function transformEmojiData(emojiData) {
  var res = emojiData.map(function (_ref3) {
    var annotation = _ref3.annotation,
      emoticon = _ref3.emoticon,
      group = _ref3.group,
      order = _ref3.order,
      shortcodes = _ref3.shortcodes,
      skins = _ref3.skins,
      tags = _ref3.tags,
      emoji = _ref3.emoji,
      version = _ref3.version;
    var tokens = _toConsumableArray(new Set(normalizeTokens([].concat(_toConsumableArray((shortcodes || []).map(extractTokens).flat()), _toConsumableArray((tags || []).map(extractTokens).flat()), _toConsumableArray(extractTokens(annotation)), [emoticon])))).sort();
    var res = {
      annotation: annotation,
      group: group,
      order: order,
      tags: tags,
      tokens: tokens,
      unicode: emoji,
      version: version
    };
    if (emoticon) {
      res.emoticon = emoticon;
    }
    if (shortcodes) {
      res.shortcodes = shortcodes;
    }
    if (skins) {
      res.skinTones = [];
      res.skinUnicodes = [];
      res.skinVersions = [];
      var _iterator3 = _createForOfIteratorHelper(skins),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref4 = _step3.value;
          var tone = _ref4.tone;
          var _emoji = _ref4.emoji;
          var _version = _ref4.version;
          res.skinTones.push(tone);
          res.skinUnicodes.push(_emoji);
          res.skinVersions.push(_version);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return res;
  });
  return res;
}

// helper functions that help compress the code better

function callStore(store, method, key, cb) {
  store[method](key).onsuccess = function (e) {
    return cb && cb(e.target.result);
  };
}
function getIDB(store, key, cb) {
  callStore(store, 'get', key, cb);
}
function getAllIDB(store, key, cb) {
  callStore(store, 'getAll', key, cb);
}
function commit(txn) {
  /* istanbul ignore else */
  if (txn.commit) {
    txn.commit();
  }
}

// like lodash's minBy
function minBy(array, func) {
  var minItem = array[0];
  for (var i = 1; i < array.length; i++) {
    var item = array[i];
    if (func(minItem) > func(item)) {
      minItem = item;
    }
  }
  return minItem;
}

// return an array of results representing all items that are found in each one of the arrays
//

function findCommonMembers(arrays, uniqByFunc) {
  var shortestArray = minBy(arrays, function (_) {
    return _.length;
  });
  var results = [];
  var _iterator4 = _createForOfIteratorHelper(shortestArray),
    _step4;
  try {
    var _loop = function _loop() {
      var item = _step4.value;
      // if this item is included in every array in the intermediate results, add it to the final results
      if (!arrays.some(function (array) {
        return array.findIndex(function (_) {
          return uniqByFunc(_) === uniqByFunc(item);
        }) === -1;
      })) {
        results.push(item);
      }
    };
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return results;
}
function isEmpty(_x2) {
  return _isEmpty.apply(this, arguments);
}
function _isEmpty() {
  _isEmpty = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(db) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          _context14.n = 1;
          return get(db, STORE_KEYVALUE, KEY_URL);
        case 1:
          return _context14.a(2, !_context14.v);
      }
    }, _callee14);
  }));
  return _isEmpty.apply(this, arguments);
}
function hasData(_x3, _x4, _x5) {
  return _hasData.apply(this, arguments);
}
function _hasData() {
  _hasData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(db, url, eTag) {
    var _yield$Promise$all, _yield$Promise$all2, oldETag, oldUrl;
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          _context15.n = 1;
          return Promise.all([KEY_ETAG, KEY_URL].map(function (key) {
            return get(db, STORE_KEYVALUE, key);
          }));
        case 1:
          _yield$Promise$all = _context15.v;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          oldETag = _yield$Promise$all2[0];
          oldUrl = _yield$Promise$all2[1];
          return _context15.a(2, oldETag === eTag && oldUrl === url);
      }
    }, _callee15);
  }));
  return _hasData.apply(this, arguments);
}
function doFullDatabaseScanForSingleResult(_x6, _x7) {
  return _doFullDatabaseScanForSingleResult.apply(this, arguments);
}
function _doFullDatabaseScanForSingleResult() {
  _doFullDatabaseScanForSingleResult = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(db, predicate) {
    var BATCH_SIZE;
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          // This batching algorithm is just a perf improvement over a basic
          // cursor. The BATCH_SIZE is an estimate of what would give the best
          // perf for doing a full DB scan (worst case).
          //
          // Mini-benchmark for determining the best batch size:
          //
          // PERF=1 pnpm build:rollup && pnpm test:adhoc
          //
          // (async () => {
          //   performance.mark('start')
          //   await $('emoji-picker').database.getEmojiByShortcode('doesnotexist')
          //   performance.measure('total', 'start')
          //   console.log(performance.getEntriesByName('total').slice(-1)[0].duration)
          // })()
          BATCH_SIZE = 50; // Typically around 150ms for 6x slowdown in Chrome for above benchmark
          return _context16.a(2, dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, txn, cb) {
            var lastKey;
            var _processNextBatch = function processNextBatch() {
              emojiStore.getAll(lastKey && IDBKeyRange.lowerBound(lastKey, true), BATCH_SIZE).onsuccess = function (e) {
                var results = e.target.result;
                var _iterator10 = _createForOfIteratorHelper(results),
                  _step10;
                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var result = _step10.value;
                    lastKey = result.unicode;
                    if (predicate(result)) {
                      return cb(result);
                    }
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }
                if (results.length < BATCH_SIZE) {
                  return cb();
                }
                _processNextBatch();
              };
            };
            _processNextBatch();
          }));
      }
    }, _callee16);
  }));
  return _doFullDatabaseScanForSingleResult.apply(this, arguments);
}
function loadData(_x8, _x9, _x0, _x1) {
  return _loadData.apply(this, arguments);
}
function _loadData() {
  _loadData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(db, emojiData, url, eTag) {
    var transformedData;
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.p = _context17.n) {
        case 0:
          _context17.p = 0;
          transformedData = transformEmojiData(emojiData);
          _context17.n = 1;
          return dbPromise(db, [STORE_EMOJI, STORE_KEYVALUE], MODE_READWRITE, function (_ref1, txn) {
            var _ref10 = _slicedToArray(_ref1, 2),
              emojiStore = _ref10[0],
              metaStore = _ref10[1];
            var oldETag;
            var oldUrl;
            var todo = 0;
            function checkFetched() {
              if (++todo === 2) {
                // 2 requests made
                onFetched();
              }
            }
            function onFetched() {
              if (oldETag === eTag && oldUrl === url) {
                // check again within the transaction to guard against concurrency, e.g. multiple browser tabs
                return;
              }
              // delete old data
              emojiStore.clear();
              // insert new data
              var _iterator11 = _createForOfIteratorHelper(transformedData),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var data = _step11.value;
                  emojiStore.put(data);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              metaStore.put(eTag, KEY_ETAG);
              metaStore.put(url, KEY_URL);
              commit(txn);
            }
            getIDB(metaStore, KEY_ETAG, function (result) {
              oldETag = result;
              checkFetched();
            });
            getIDB(metaStore, KEY_URL, function (result) {
              oldUrl = result;
              checkFetched();
            });
          });
        case 1:
          _context17.p = 1;
          return _context17.f(1);
        case 2:
          return _context17.a(2);
      }
    }, _callee17, null, [[0,, 1, 2]]);
  }));
  return _loadData.apply(this, arguments);
}
function _getEmojiByGroup2(_x10, _x11) {
  return _getEmojiByGroup.apply(this, arguments);
}
function _getEmojiByGroup() {
  _getEmojiByGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(db, group) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, txn, cb) {
            var range = IDBKeyRange.bound([group, 0], [group + 1, 0], false, true);
            getAllIDB(emojiStore.index(INDEX_GROUP_AND_ORDER), range, cb);
          }));
      }
    }, _callee18);
  }));
  return _getEmojiByGroup.apply(this, arguments);
}
function _getEmojiBySearchQuery2(_x12, _x13) {
  return _getEmojiBySearchQuery.apply(this, arguments);
} // This could have been implemented as an IDB index on shortcodes, but it seemed wasteful to do that
// when we can already query by tokens and this will give us what we're looking for 99.9% of the time
function _getEmojiBySearchQuery() {
  _getEmojiBySearchQuery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(db, query) {
    var tokens;
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          tokens = normalizeTokens(extractTokens(query));
          if (tokens.length) {
            _context19.n = 1;
            break;
          }
          return _context19.a(2, []);
        case 1:
          return _context19.a(2, dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, txn, cb) {
            // get all results that contain all tokens (i.e. an AND query)
            var intermediateResults = [];
            var checkDone = function checkDone() {
              if (intermediateResults.length === tokens.length) {
                onDone();
              }
            };
            var onDone = function onDone() {
              var results = findCommonMembers(intermediateResults, function (_) {
                return _.unicode;
              });
              cb(results.sort(function (a, b) {
                return a.order < b.order ? -1 : 1;
              }));
            };
            for (var i = 0; i < tokens.length; i++) {
              var token = tokens[i];
              var range = i === tokens.length - 1 ? IDBKeyRange.bound(token, token + "\uFFFF", false, true) // treat last token as a prefix search
              : IDBKeyRange.only(token); // treat all other tokens as an exact match
              getAllIDB(emojiStore.index(INDEX_TOKENS), range, function (result) {
                intermediateResults.push(result);
                checkDone();
              });
            }
          }));
      }
    }, _callee19);
  }));
  return _getEmojiBySearchQuery.apply(this, arguments);
}
function _getEmojiByShortcode2(_x14, _x15) {
  return _getEmojiByShortcode.apply(this, arguments);
}
function _getEmojiByShortcode() {
  _getEmojiByShortcode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(db, shortcode) {
    var emojis, predicate, _t1;
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          _context20.n = 1;
          return _getEmojiBySearchQuery2(db, shortcode);
        case 1:
          emojis = _context20.v;
          if (emojis.length) {
            _context20.n = 4;
            break;
          }
          predicate = function predicate(_) {
            return (_.shortcodes || []).includes(shortcode.toLowerCase());
          };
          _context20.n = 2;
          return doFullDatabaseScanForSingleResult(db, predicate);
        case 2:
          _t1 = _context20.v;
          if (_t1) {
            _context20.n = 3;
            break;
          }
          _t1 = null;
        case 3:
          return _context20.a(2, _t1);
        case 4:
          return _context20.a(2, emojis.filter(function (_) {
            var lowerShortcodes = (_.shortcodes || []).map(function (_) {
              return _.toLowerCase();
            });
            return lowerShortcodes.includes(shortcode.toLowerCase());
          })[0] || null);
      }
    }, _callee20);
  }));
  return _getEmojiByShortcode.apply(this, arguments);
}
function getEmojiByUnicode(_x16, _x17) {
  return _getEmojiByUnicode.apply(this, arguments);
}
function _getEmojiByUnicode() {
  _getEmojiByUnicode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(db, unicode) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, txn, cb) {
            return getIDB(emojiStore, unicode, function (result) {
              if (result) {
                return cb(result);
              }
              getIDB(emojiStore.index(INDEX_SKIN_UNICODE), unicode, function (result) {
                return cb(result || null);
              });
            });
          }));
      }
    }, _callee21);
  }));
  return _getEmojiByUnicode.apply(this, arguments);
}
function get(db, storeName, key) {
  return dbPromise(db, storeName, MODE_READONLY, function (store, txn, cb) {
    return getIDB(store, key, cb);
  });
}
function set(db, storeName, key, value) {
  return dbPromise(db, storeName, MODE_READWRITE, function (store, txn) {
    store.put(value, key);
    commit(txn);
  });
}
function _incrementFavoriteEmojiCount(db, unicode) {
  return dbPromise(db, STORE_FAVORITES, MODE_READWRITE, function (store, txn) {
    return getIDB(store, unicode, function (result) {
      store.put((result || 0) + 1, unicode);
      commit(txn);
    });
  });
}
function _getTopFavoriteEmoji(db, customEmojiIndex, limit) {
  if (limit === 0) {
    return [];
  }
  return dbPromise(db, [STORE_FAVORITES, STORE_EMOJI], MODE_READONLY, function (_ref5, txn, cb) {
    var _ref6 = _slicedToArray(_ref5, 2),
      favoritesStore = _ref6[0],
      emojiStore = _ref6[1];
    var results = [];
    favoritesStore.index(INDEX_COUNT).openCursor(undefined, 'prev').onsuccess = function (e) {
      var cursor = e.target.result;
      if (!cursor) {
        // no more results
        return cb(results);
      }
      function addResult(result) {
        results.push(result);
        if (results.length === limit) {
          return cb(results); // done, reached the limit
        }
        cursor.continue();
      }
      var unicodeOrName = cursor.primaryKey;
      var custom = customEmojiIndex.byName(unicodeOrName);
      if (custom) {
        return addResult(custom);
      }
      // This could be done in parallel (i.e. make the cursor and the get()s parallelized),
      // but my testing suggests it's not actually faster.
      getIDB(emojiStore, unicodeOrName, function (emoji) {
        if (emoji) {
          return addResult(emoji);
        }
        // emoji not found somehow, ignore (may happen if custom emoji change)
        cursor.continue();
      });
    };
  });
}

// trie data structure for prefix searches
// loosely based on https://github.com/nolanlawson/substring-trie

var CODA_MARKER = ''; // marks the end of the string

function trie(arr, itemToTokens) {
  var map = new Map();
  var _iterator5 = _createForOfIteratorHelper(arr),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var item = _step5.value;
      var tokens = itemToTokens(item);
      var _iterator7 = _createForOfIteratorHelper(tokens),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var token = _step7.value;
          var currentMap = map;
          for (var i = 0; i < token.length; i++) {
            var char = token.charAt(i);
            var nextMap = currentMap.get(char);
            if (!nextMap) {
              nextMap = new Map();
              currentMap.set(char, nextMap);
            }
            currentMap = nextMap;
          }
          var valuesAtCoda = currentMap.get(CODA_MARKER);
          if (!valuesAtCoda) {
            valuesAtCoda = [];
            currentMap.set(CODA_MARKER, valuesAtCoda);
          }
          valuesAtCoda.push(item);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  var search = function search(query, exact) {
    var currentMap = map;
    for (var i = 0; i < query.length; i++) {
      var char = query.charAt(i);
      var nextMap = currentMap.get(char);
      if (nextMap) {
        currentMap = nextMap;
      } else {
        return [];
      }
    }
    if (exact) {
      var _results = currentMap.get(CODA_MARKER);
      return _results || [];
    }
    var results = [];
    // traverse
    var queue = [currentMap];
    while (queue.length) {
      var _currentMap = queue.shift();
      var entriesSortedByKey = _toConsumableArray(_currentMap.entries()).sort(function (a, b) {
        return a[0] < b[0] ? -1 : 1;
      });
      var _iterator6 = _createForOfIteratorHelper(entriesSortedByKey),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref7 = _step6.value;
          var _ref8 = _slicedToArray(_ref7, 2);
          var key = _ref8[0];
          var value = _ref8[1];
          if (key === CODA_MARKER) {
            // CODA_MARKER always comes first; it's the empty string
            results.push.apply(results, _toConsumableArray(value));
          } else {
            queue.push(value);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    return results;
  };
  return search;
}
var requiredKeys$1 = ['name', 'url'];
function assertCustomEmojis(customEmojis) {
  var isArray = customEmojis && Array.isArray(customEmojis);
  var firstItemIsFaulty = isArray && customEmojis.length && (!customEmojis[0] || requiredKeys$1.some(function (key) {
    return !(key in customEmojis[0]);
  }));
  if (!isArray || firstItemIsFaulty) {
    throw new Error('Custom emojis are in the wrong format');
  }
}
function customEmojiIndex(customEmojis) {
  assertCustomEmojis(customEmojis);
  var sortByName = function sortByName(a, b) {
    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
  };

  //
  // all()
  //
  var all = customEmojis.sort(sortByName);

  //
  // search()
  //
  var emojiToTokens = function emojiToTokens(emoji) {
    var set = new Set();
    if (emoji.shortcodes) {
      var _iterator8 = _createForOfIteratorHelper(emoji.shortcodes),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var shortcode = _step8.value;
          var _iterator9 = _createForOfIteratorHelper(extractTokens(shortcode)),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var token = _step9.value;
              set.add(token);
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    return set;
  };
  var searchTrie = trie(customEmojis, emojiToTokens);
  var searchByExactMatch = function searchByExactMatch(_) {
    return searchTrie(_, true);
  };
  var searchByPrefix = function searchByPrefix(_) {
    return searchTrie(_, false);
  };

  // Search by query for custom emoji. Similar to how we do this in IDB, the last token
  // is treated as a prefix search, but every other one is treated as an exact match.
  // Then we AND the results together
  var search = function search(query) {
    var tokens = extractTokens(query);
    var intermediateResults = tokens.map(function (token, i) {
      return (i < tokens.length - 1 ? searchByExactMatch : searchByPrefix)(token);
    });
    return findCommonMembers(intermediateResults, function (_) {
      return _.name;
    }).sort(sortByName);
  };

  //
  // byShortcode, byName
  //
  var shortcodeToEmoji = new Map();
  var nameToEmoji = new Map();
  var _iterator0 = _createForOfIteratorHelper(customEmojis),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var customEmoji = _step0.value;
      nameToEmoji.set(customEmoji.name.toLowerCase(), customEmoji);
      var _iterator1 = _createForOfIteratorHelper(customEmoji.shortcodes || []),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var shortcode = _step1.value;
          shortcodeToEmoji.set(shortcode.toLowerCase(), customEmoji);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  var byShortcode = function byShortcode(shortcode) {
    return shortcodeToEmoji.get(shortcode.toLowerCase());
  };
  var byName = function byName(name) {
    return nameToEmoji.get(name.toLowerCase());
  };
  return {
    all: all,
    search: search,
    byShortcode: byShortcode,
    byName: byName
  };
}
var isFirefoxContentScript = typeof wrappedJSObject !== 'undefined';

// remove some internal implementation details, i.e. the "tokens" array on the emoji object
// essentially, convert the emoji from the version stored in IDB to the version used in-memory
function cleanEmoji(emoji) {
  if (!emoji) {
    return emoji;
  }
  // if inside a Firefox content script, need to clone the emoji object to prevent Firefox from complaining about
  // cross-origin object. See: https://github.com/nolanlawson/emoji-picker-element/issues/356
  /* istanbul ignore if */
  if (isFirefoxContentScript) {
    emoji = structuredClone(emoji);
  }
  delete emoji.tokens;
  if (emoji.skinTones) {
    var len = emoji.skinTones.length;
    emoji.skins = Array(len);
    for (var i = 0; i < len; i++) {
      emoji.skins[i] = {
        tone: emoji.skinTones[i],
        unicode: emoji.skinUnicodes[i],
        version: emoji.skinVersions[i]
      };
    }
    delete emoji.skinTones;
    delete emoji.skinUnicodes;
    delete emoji.skinVersions;
  }
  return emoji;
}
function warnETag(eTag) {
  if (!eTag) {
    console.warn('emoji-picker-element is more efficient if the dataSource server exposes an ETag header.');
  }
}
var requiredKeys = ['annotation', 'emoji', 'group', 'order', 'version'];
function assertEmojiData(emojiData) {
  if (!emojiData || !Array.isArray(emojiData) || !emojiData[0] || _typeof(emojiData[0]) !== 'object' || requiredKeys.some(function (key) {
    return !(key in emojiData[0]);
  })) {
    throw new Error('Emoji data is in the wrong format');
  }
}
function assertStatus(response, dataSource) {
  if (Math.floor(response.status / 100) !== 2) {
    throw new Error('Failed to fetch: ' + dataSource + ':  ' + response.status);
  }
}
function getETag(_x18) {
  return _getETag.apply(this, arguments);
}
function _getETag() {
  _getETag = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(dataSource) {
    var response, eTag;
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          _context22.n = 1;
          return fetch(dataSource, {
            method: 'HEAD'
          });
        case 1:
          response = _context22.v;
          assertStatus(response, dataSource);
          eTag = response.headers.get('etag');
          warnETag(eTag);
          return _context22.a(2, eTag);
      }
    }, _callee22);
  }));
  return _getETag.apply(this, arguments);
}
function getETagAndData(_x19) {
  return _getETagAndData.apply(this, arguments);
} // TODO: including these in blob-util.ts causes typedoc to generate docs for them,
// even with --excludePrivate ¯\_(ツ)_/¯
/** @private */
/**
 * Convert an `ArrayBuffer` to a binary string.
 *
 * Example:
 *
 * ```js
 * var myString = blobUtil.arrayBufferToBinaryString(arrayBuff)
 * ```
 *
 * @param buffer - array buffer
 * @returns binary string
 */
function _getETagAndData() {
  _getETagAndData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(dataSource) {
    var response, eTag, emojiData;
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          _context23.n = 1;
          return fetch(dataSource);
        case 1:
          response = _context23.v;
          assertStatus(response, dataSource);
          eTag = response.headers.get('etag');
          warnETag(eTag);
          _context23.n = 2;
          return response.json();
        case 2:
          emojiData = _context23.v;
          assertEmojiData(emojiData);
          return _context23.a(2, [eTag, emojiData]);
      }
    }, _callee23);
  }));
  return _getETagAndData.apply(this, arguments);
}
function arrayBufferToBinaryString(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var length = bytes.byteLength;
  var i = -1;
  while (++i < length) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary;
}
/**
 * Convert a binary string to an `ArrayBuffer`.
 *
 * ```js
 * var myBuffer = blobUtil.binaryStringToArrayBuffer(binaryString)
 * ```
 *
 * @param binary - binary string
 * @returns array buffer
 */
function binaryStringToArrayBuffer(binary) {
  var length = binary.length;
  var buf = new ArrayBuffer(length);
  var arr = new Uint8Array(buf);
  var i = -1;
  while (++i < length) {
    arr[i] = binary.charCodeAt(i);
  }
  return buf;
}

// generate a checksum based on the stringified JSON
function jsonChecksum(_x20) {
  return _jsonChecksum.apply(this, arguments);
}
function _jsonChecksum() {
  _jsonChecksum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(object) {
    var inString, inBuffer, outBuffer, outBinString, res;
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          inString = JSON.stringify(object);
          inBuffer = binaryStringToArrayBuffer(inString); // this does not need to be cryptographically secure, SHA-1 is fine
          _context24.n = 1;
          return crypto.subtle.digest('SHA-1', inBuffer);
        case 1:
          outBuffer = _context24.v;
          outBinString = arrayBufferToBinaryString(outBuffer);
          res = btoa(outBinString);
          return _context24.a(2, res);
      }
    }, _callee24);
  }));
  return _jsonChecksum.apply(this, arguments);
}
function doCheckForUpdates(_x21, _x22) {
  return _doCheckForUpdates.apply(this, arguments);
}
function _doCheckForUpdates() {
  _doCheckForUpdates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(db, dataSource) {
    var emojiData, eTag, eTagAndData, _eTagAndData;
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          _context25.n = 1;
          return getETag(dataSource);
        case 1:
          eTag = _context25.v;
          if (eTag) {
            _context25.n = 4;
            break;
          }
          _context25.n = 2;
          return getETagAndData(dataSource);
        case 2:
          eTagAndData = _context25.v;
          eTag = eTagAndData[0];
          emojiData = eTagAndData[1];
          if (eTag) {
            _context25.n = 4;
            break;
          }
          _context25.n = 3;
          return jsonChecksum(emojiData);
        case 3:
          eTag = _context25.v;
        case 4:
          _context25.n = 5;
          return hasData(db, dataSource, eTag);
        case 5:
          if (!_context25.v) {
            _context25.n = 6;
            break;
          }
          ;
          _context25.n = 9;
          break;
        case 6:
          if (emojiData) {
            _context25.n = 8;
            break;
          }
          _context25.n = 7;
          return getETagAndData(dataSource);
        case 7:
          _eTagAndData = _context25.v;
          emojiData = _eTagAndData[1];
        case 8:
          _context25.n = 9;
          return loadData(db, emojiData, dataSource, eTag);
        case 9:
          return _context25.a(2);
      }
    }, _callee25);
  }));
  return _doCheckForUpdates.apply(this, arguments);
}
function loadDataForFirstTime(_x23, _x24) {
  return _loadDataForFirstTime.apply(this, arguments);
}
function _loadDataForFirstTime() {
  _loadDataForFirstTime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(db, dataSource) {
    var _yield$getETagAndData, _yield$getETagAndData2, eTag, emojiData;
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          _context26.n = 1;
          return getETagAndData(dataSource);
        case 1:
          _yield$getETagAndData = _context26.v;
          _yield$getETagAndData2 = _slicedToArray(_yield$getETagAndData, 2);
          eTag = _yield$getETagAndData2[0];
          emojiData = _yield$getETagAndData2[1];
          if (eTag) {
            _context26.n = 3;
            break;
          }
          _context26.n = 2;
          return jsonChecksum(emojiData);
        case 2:
          eTag = _context26.v;
        case 3:
          _context26.n = 4;
          return loadData(db, emojiData, dataSource, eTag);
        case 4:
          return _context26.a(2);
      }
    }, _callee26);
  }));
  return _loadDataForFirstTime.apply(this, arguments);
}
function checkForUpdates(_x25, _x26) {
  return _checkForUpdates.apply(this, arguments);
}
function _checkForUpdates() {
  _checkForUpdates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(db, dataSource) {
    var _t10;
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.p = _context27.n) {
        case 0:
          _context27.p = 0;
          _context27.n = 1;
          return doCheckForUpdates(db, dataSource);
        case 1:
          _context27.n = 3;
          break;
        case 2:
          _context27.p = 2;
          _t10 = _context27.v;
          if (!(_t10.name !== 'InvalidStateError')) {
            _context27.n = 3;
            break;
          }
          throw _t10;
        case 3:
          return _context27.a(2);
      }
    }, _callee27, null, [[0, 2]]);
  }));
  return _checkForUpdates.apply(this, arguments);
}
var Database = exports.default = /*#__PURE__*/function () {
  function Database() {
    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref9$dataSource = _ref9.dataSource,
      dataSource = _ref9$dataSource === void 0 ? DEFAULT_DATA_SOURCE : _ref9$dataSource,
      _ref9$locale = _ref9.locale,
      locale = _ref9$locale === void 0 ? DEFAULT_LOCALE : _ref9$locale,
      _ref9$customEmoji = _ref9.customEmoji,
      customEmoji = _ref9$customEmoji === void 0 ? [] : _ref9$customEmoji;
    _classCallCheck(this, Database);
    this.dataSource = dataSource;
    this.locale = locale;
    this._dbName = "emoji-picker-element-".concat(this.locale);
    this._db = undefined;
    this._lazyUpdate = undefined;
    this._custom = customEmojiIndex(customEmoji);
    this._clear = this._clear.bind(this);
    this._ready = this._init();
  }
  return _createClass(Database, [{
    key: "_init",
    value: function () {
      var _init2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var db, dataSource, empty;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return openDatabase(this._dbName);
            case 1:
              db = this._db = _context.v;
              addOnCloseListener(this._dbName, this._clear);
              dataSource = this.dataSource;
              _context.n = 2;
              return isEmpty(db);
            case 2:
              empty = _context.v;
              if (!empty) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return loadDataForFirstTime(db, dataSource);
            case 3:
              _context.n = 5;
              break;
            case 4:
              // offline-first - do an update asynchronously
              this._lazyUpdate = checkForUpdates(db, dataSource);
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function _init() {
        return _init2.apply(this, arguments);
      }
      return _init;
    }()
  }, {
    key: "ready",
    value: function () {
      var _ready = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        var checkReady;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              checkReady = /*#__PURE__*/function () {
                var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        if (!_this._ready) {
                          _this._ready = _this._init();
                        }
                        return _context2.a(2, _this._ready);
                    }
                  }, _callee2);
                }));
                return function checkReady() {
                  return _ref0.apply(this, arguments);
                };
              }();
              _context3.n = 1;
              return checkReady();
            case 1:
              if (this._db) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return checkReady();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function ready() {
        return _ready.apply(this, arguments);
      }
      return ready;
    }()
  }, {
    key: "getEmojiByGroup",
    value: function () {
      var _getEmojiByGroup3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(group) {
        var _t, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              assertNumber(group);
              _context4.n = 1;
              return this.ready();
            case 1:
              _t = uniqEmoji;
              _context4.n = 2;
              return _getEmojiByGroup2(this._db, group);
            case 2:
              _t2 = _context4.v;
              return _context4.a(2, _t(_t2).map(cleanEmoji));
          }
        }, _callee4, this);
      }));
      function getEmojiByGroup(_x27) {
        return _getEmojiByGroup3.apply(this, arguments);
      }
      return getEmojiByGroup;
    }()
  }, {
    key: "getEmojiBySearchQuery",
    value: function () {
      var _getEmojiBySearchQuery3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(query) {
        var customs, natives, _t3, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              assertNonEmptyString(query);
              _context5.n = 1;
              return this.ready();
            case 1:
              customs = this._custom.search(query);
              _t3 = uniqEmoji;
              _context5.n = 2;
              return _getEmojiBySearchQuery2(this._db, query);
            case 2:
              _t4 = _context5.v;
              natives = _t3(_t4).map(cleanEmoji);
              return _context5.a(2, [].concat(_toConsumableArray(customs), _toConsumableArray(natives)));
          }
        }, _callee5, this);
      }));
      function getEmojiBySearchQuery(_x28) {
        return _getEmojiBySearchQuery3.apply(this, arguments);
      }
      return getEmojiBySearchQuery;
    }()
  }, {
    key: "getEmojiByShortcode",
    value: function () {
      var _getEmojiByShortcode3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shortcode) {
        var custom, _t5, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              assertNonEmptyString(shortcode);
              _context6.n = 1;
              return this.ready();
            case 1:
              custom = this._custom.byShortcode(shortcode);
              if (!custom) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, custom);
            case 2:
              _t5 = cleanEmoji;
              _context6.n = 3;
              return _getEmojiByShortcode2(this._db, shortcode);
            case 3:
              _t6 = _context6.v;
              return _context6.a(2, _t5(_t6));
          }
        }, _callee6, this);
      }));
      function getEmojiByShortcode(_x29) {
        return _getEmojiByShortcode3.apply(this, arguments);
      }
      return getEmojiByShortcode;
    }()
  }, {
    key: "getEmojiByUnicodeOrName",
    value: function () {
      var _getEmojiByUnicodeOrName = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(unicodeOrName) {
        var custom, _t7, _t8;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              assertNonEmptyString(unicodeOrName);
              _context7.n = 1;
              return this.ready();
            case 1:
              custom = this._custom.byName(unicodeOrName);
              if (!custom) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2, custom);
            case 2:
              _t7 = cleanEmoji;
              _context7.n = 3;
              return getEmojiByUnicode(this._db, unicodeOrName);
            case 3:
              _t8 = _context7.v;
              return _context7.a(2, _t7(_t8));
          }
        }, _callee7, this);
      }));
      function getEmojiByUnicodeOrName(_x30) {
        return _getEmojiByUnicodeOrName.apply(this, arguments);
      }
      return getEmojiByUnicodeOrName;
    }()
  }, {
    key: "getPreferredSkinTone",
    value: function () {
      var _getPreferredSkinTone = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _t9;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.ready();
            case 1:
              _context8.n = 2;
              return get(this._db, STORE_KEYVALUE, KEY_PREFERRED_SKINTONE);
            case 2:
              _t9 = _context8.v;
              if (_t9) {
                _context8.n = 3;
                break;
              }
              _t9 = 0;
            case 3:
              return _context8.a(2, _t9);
          }
        }, _callee8, this);
      }));
      function getPreferredSkinTone() {
        return _getPreferredSkinTone.apply(this, arguments);
      }
      return getPreferredSkinTone;
    }()
  }, {
    key: "setPreferredSkinTone",
    value: function () {
      var _setPreferredSkinTone = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(skinTone) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              assertNumber(skinTone);
              _context9.n = 1;
              return this.ready();
            case 1:
              return _context9.a(2, set(this._db, STORE_KEYVALUE, KEY_PREFERRED_SKINTONE, skinTone));
          }
        }, _callee9, this);
      }));
      function setPreferredSkinTone(_x31) {
        return _setPreferredSkinTone.apply(this, arguments);
      }
      return setPreferredSkinTone;
    }()
  }, {
    key: "incrementFavoriteEmojiCount",
    value: function () {
      var _incrementFavoriteEmojiCount2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(unicodeOrName) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              assertNonEmptyString(unicodeOrName);
              _context0.n = 1;
              return this.ready();
            case 1:
              return _context0.a(2, _incrementFavoriteEmojiCount(this._db, unicodeOrName));
          }
        }, _callee0, this);
      }));
      function incrementFavoriteEmojiCount(_x32) {
        return _incrementFavoriteEmojiCount2.apply(this, arguments);
      }
      return incrementFavoriteEmojiCount;
    }()
  }, {
    key: "getTopFavoriteEmoji",
    value: function () {
      var _getTopFavoriteEmoji2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(limit) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              assertNumber(limit);
              _context1.n = 1;
              return this.ready();
            case 1:
              _context1.n = 2;
              return _getTopFavoriteEmoji(this._db, this._custom, limit);
            case 2:
              return _context1.a(2, _context1.v.map(cleanEmoji));
          }
        }, _callee1, this);
      }));
      function getTopFavoriteEmoji(_x33) {
        return _getTopFavoriteEmoji2.apply(this, arguments);
      }
      return getTopFavoriteEmoji;
    }()
  }, {
    key: "customEmoji",
    get: function get() {
      return this._custom.all;
    },
    set: function set(customEmojis) {
      this._custom = customEmojiIndex(customEmojis);
    }
  }, {
    key: "_shutdown",
    value: function () {
      var _shutdown2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _t0;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.n = 1;
              return this.ready();
            case 1:
              _context10.p = 1;
              _context10.n = 2;
              return this._lazyUpdate;
            case 2:
              _context10.n = 4;
              break;
            case 3:
              _context10.p = 3;
              _t0 = _context10.v;
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this, [[1, 3]]);
      }));
      function _shutdown() {
        return _shutdown2.apply(this, arguments);
      }
      return _shutdown;
    }() // clear references to IDB, e.g. during a close event
  }, {
    key: "_clear",
    value: function _clear() {
      // We don't need to call removeEventListener or remove the manual "close" listeners.
      // The memory leak tests prove this is unnecessary. It's because:
      // 1) IDBDatabases that can no longer fire "close" automatically have listeners GCed
      // 2) we clear the manual close listeners in databaseLifecycle.js.
      this._db = this._ready = this._lazyUpdate = undefined;
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return this._shutdown();
            case 1:
              _context11.n = 2;
              return closeDatabase(this._dbName);
            case 2:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return this._shutdown();
            case 1:
              _context12.n = 2;
              return deleteDatabase(this._dbName);
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function _delete() {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }]);
}();